import { render } from "./FormSelect.vue?vue&type=template&id=a4185bcc"
import script from "./FormSelect.vue?vue&type=script&lang=js"
export * from "./FormSelect.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/Form/FormSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a4185bcc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a4185bcc', __exports__)) {
    console.log('reload')
    api.reload('a4185bcc', __exports__)
  }
  
  module.hot.accept("./FormSelect.vue?vue&type=template&id=a4185bcc", () => {
    console.log('re-render')
    api.rerender('a4185bcc', render)
  })

}


export default __exports__